import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LookupPatient from './LookupPatient';
import LookupPatientRPM from './LookupPatientRPM';

const PatientManagementRoutes = () => (
  <Routes>
    <Route path='lookup' element={<LookupPatient />} />
    <Route path='lookup-rpm' element={<LookupPatientRPM />} />
    {/* fallback for default ... */}
    <Route path='' element={<LookupPatient />} />
  </Routes>
);

export default PatientManagementRoutes;
